import React from 'react'
import {
  SeriesTypes,
  type TimeRange,
  type ChartSeries,
} from 'legacy/components/DataViz/dataViz.types'
import ChartFooterLabel from 'legacy/components/DataViz/Charts/ChartFooter/ChartFooterLabel'
import { type ChartFooterProps } from 'legacy/components/DataViz/Charts/ChartFooter/ChartFooter'
import { type IntlShape } from 'react-intl'

type GenerateFooterLabel = Pick<ChartFooterProps, 'intl' | 'timeRange'>

export function generateIntlDates(intl: IntlShape, type: SeriesTypes, timeRange: TimeRange) {
  switch (type) {
    case SeriesTypes.ThisPeriod:
      return {
        start: intl.formatDate(timeRange.this_period.start),
        end: intl.formatDate(timeRange.this_period.end),
      }
    case SeriesTypes.LastPeriod:
      return {
        start: timeRange.last_period ? intl.formatDate(timeRange.last_period.start) : '',
        end: timeRange.last_period ? intl.formatDate(timeRange.last_period.end) : '',
      }
    default:
      return {}
  }
}

export function generateFooterLabel({ intl, timeRange }: GenerateFooterLabel) {
  return ({ type, label }: ChartSeries) => {
    const labelText = intl.formatMessage(
      { id: `charts.series.labels.${label}` },
      generateIntlDates(intl, type, timeRange)
    )
    return <ChartFooterLabel key={label} labelText={labelText} seriesType={type} />
  }
}
